import styled from 'styled-components';
import { Icon } from '../../icon/Icon';

interface SurveyCheckboxInputProps {
  title: string;
  label?: string;
  isChecked: boolean;
  onClick?: () => void;
}

export const SurveyCheckboxInput = ({ title, label, isChecked, onClick }: SurveyCheckboxInputProps) => {
  return (
    <Container onClick={onClick}>
      <InputTextContainer>
        {label && <InputLabel>{label}</InputLabel>}
        <InputTitle>{title}</InputTitle>
      </InputTextContainer>

      {isChecked ? (
        <CheckedCheckbox>
          <Icon name={'CheckBox'} width={10} height={7} />
        </CheckedCheckbox>
      ) : (
        <DefaultCheckbox />
      )}
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  height: 72px;

  display: flex;
  justify-content: space-between;
  align-items: center;

  padding: 30px 16px;

  border-radius: var(--radius-medium, 8px);
  background: var(--Light-Scheme-Monochrome-grey10, #f2f2f7);

  cursor: pointer;
`;

const InputTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;

  gap: 8px;
`;

const InputLabel = styled.span`
  color: var(--Light-Scheme-Monochrome-grey100, #858894);

  /* System/Small/s-regular */
  font-family: Pretendard;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 85%; /* 10.2px */
`;

const InputTitle = styled.span`
  color: var(--Light-Scheme-Monochrome-offblack, #505363);

  /* System/Medium/m-regular */
  font-family: Pretendard;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 85%; /* 11.9px */
`;

const DefaultCheckbox = styled.div`
  width: 16px;
  height: 16px;

  display: flex;
  justify-content: center;
  align-items: center;

  gap: 8px;

  border-radius: var(--radius-small, 4px);
  border: 1px solid var(--Light-Scheme-Monochrome-grey30, #d5d5e3);
  background: var(--Light-Scheme-Monochrome-white, #fff);
`;

const CheckedCheckbox = styled.div`
  width: 16px;
  height: 16px;

  display: flex;
  justify-content: center;
  align-items: center;

  gap: 8px;

  border-radius: var(--radius-small, 4px);
  background: var(--Light-Scheme-Color-primary-blue, #196eff);
`;
